(function () {
    'use strict';
    angular.module('Services').service('AffiliateAccountsTableService', AffiliateAccountsTableService);
    AffiliateAccountsTableService.$inject=[
        '$location',
        '$routeParams',
        'TableLiteFactory',
        'AffiliateService',
        'toastr',
        'ConfirmationModalFactory'
    ];



    function AffiliateAccountsTableService (
        $location,
        $routeParams,
        TableLiteFactory,
        AffiliateService,
        toastr,
        ConfirmationModalFactory

    ){

        return function (){
            const vm =this;
            vm.items=[];
            vm.paramId = $routeParams.id;
            const confirmDelete = new ConfirmationModalFactory({}, {
                message: 'messages.warning.deleteAdminAccount.MESSAGE',
                code: 'messages.warning.deleteAdminAccount.CODE'
            });
            const tableData = {
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    noExtract: true,

                },
                optionAddOns:{
                    buttons: [{
                        class: 'btn-success',
                        label: 'Add New Accounts',
                        tooltip: 'Report Approvals',
                        onClick: function () {
                            // showDriverDetailsModal()
                            $location.path('/affiliates-sales/accounts/'+vm.paramId+'/new');
                        }
                    }]
                },
                headers:[
                    {
                        label: 'Name',
                        viewName: 'firstName',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            items:[],
                            onSubmit: header => {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        refresh:function(model){

                        },
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Email',
                        viewName: 'email',
                        filterName:'email',
                        
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Address',
                        viewName: 'address',
                        filterName:'addressLine1',
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                   
                    {
                        label: 'Action',
                        viewName: 'action',
                       
                    }
                ],
                data:[]



            }

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: AffiliateService.getUserMarketing,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err.message,'Code: '+err.code);
                    },
                    defaultFilters : {
                        companyMarketingId:vm.paramId,
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    } 
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
              
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    
                   
                    item.firstName = item.firstName + ' ' + item.lastName;
                    item.email = item.email;
                    item.address = {
                        type:'multiLine',
                        list: [item.addressLine1, item.addressLine2]
                    }
                    item.href='/affiliates-sales/accounts/edit/'+ item.id;
                    item.status = 'N/A';
                    item.action = {
                        type: 'button',
                        buttons: [{
                            text: 'Delete',
                            class: 'btn btn-danger',
                            action: row => {
                                onDeleteBtnAccountClicked(item)
                            }
                        }]
                    }

                    vm.items.push({name:item.firstName, value: item.id});
                    tableData.data.push(item);
                });
            };

            this.tableData = tableData;

            function onDeleteBtnAccountClicked(item) {
                confirmDelete.getInstance().result.then(function(cond) {
                    if (!cond) { return; }
                    deletePartnerCompany(item);
                });
            }

            function deletePartnerCompany(data){
                AffiliateService.deleteUserMarketing(
                    res=>{
                        toastr.success('Succefully Deleted!');
                        tableActions.sendRequest({})
                    },
                    err=>{
                        toastr.error(err.message,err.code)
                    },data.id)
            }
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/affiliateTable/accounts/AffiliateAccountsTableService.js